/** @format */

import { getUserProfile, userIsBlock, getUserOrder } from "../../store/user/user.action";
import { connect, useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getDefaultCurrency } from "../../store/currency/currency.action";
import { formatAmount } from "../../extra/functions";
import { getImageUrl } from "../../../util/getImageUrl";

const UserProfile = (props) => {
	const { userProfile, order, totalOrder } = useSelector((state) => state.user);
	const { defaultCurrency } = useSelector((state) => state.currency);
	const { state } = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const [size, setSize] = useState(10);
	const [data, setData] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [status, setStatus] = useState("All");
	const [dropdownOpen, setDropdownOpen] = useState(false);

	useEffect(() => {
		dispatch(getUserProfile(state));
		dispatch(getDefaultCurrency());
	}, [dispatch, state]);

	useEffect(() => {
		dispatch(getUserOrder(state, currentPage, size, status));
	}, [dispatch, state, currentPage, size, status]);

	useEffect(() => {
		setData(order);
	}, [order]);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (!event.target.closest(".dropdown")) {
				setDropdownOpen(false);
			}
		};
		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, []);

	const handleOpen = (id) => {
		navigate("/admin/order/orderDetail", {
			state: id,
		});
	};

	const statusColorMap = {
		Pending: "status-badge--pending",
		Confirmed: "status-badge--confirmed",
		Cancelled: "status-badge--cancelled",
		"Out Of Delivery": "status-badge--out-of-delivery",
		Delivered: "status-badge--delivered",
	};

	return (
		<div className='container-fluid px-4 mt-4'>
			{/* Header */}
			<div className='d-flex justify-content-between align-items-center mb-4'>
				<div>
					<h4 style={{ fontWeight: 700, color: "#0f172a", margin: 0 }}>Customer #{userProfile?.uniqueId}</h4>
					<p style={{ color: "#64748b", fontSize: "13px", margin: "4px 0 0" }}>
						{userProfile?.date
							? new Date(userProfile.date).toLocaleString("en-GB", {
									day: "2-digit",
									month: "short",
									year: "numeric",
									hour: "2-digit",
									minute: "2-digit",
									hour12: true,
								})
							: "-"}
					</p>
				</div>
				<button onClick={() => navigate(-1)} className='btn' style={{ border: "1px solid #e2e8f0", borderRadius: "8px", padding: "8px 20px", fontWeight: 500, color: "#334155", fontSize: "14px" }}>
					← Back
				</button>
			</div>

			<div className='row'>
				{/* User Profile Card */}
				<div className='col-xl-3 col-md-12 mb-4'>
					<div style={{ background: "#fff", borderRadius: "16px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px rgba(0,0,0,0.06)", overflow: "hidden" }}>
						{/* Profile Header */}
						<div style={{ background: "linear-gradient(135deg, #e54a13 0%, #f08c5a 100%)", padding: "32px 20px 48px", textAlign: "center", position: "relative" }}>
							<img
								src={getImageUrl(userProfile?.image) || "/dummy.png"}
								width={88}
								height={88}
								style={{ borderRadius: "16px", objectFit: "cover", border: "3px solid rgba(255,255,255,0.3)" }}
								alt=''
								onError={(e) => {
									e.target.onerror = null;
									e.target.src = "/dummy.png";
								}}
							/>
							<h5 style={{ color: "#fff", fontWeight: 700, marginTop: "12px", marginBottom: "2px" }}>
								{userProfile?.firstName} {userProfile?.lastName}
							</h5>
							<span style={{ color: "rgba(255,255,255,0.8)", fontSize: "13px" }}>@{userProfile?.firstName}</span>
						</div>

						{/* Stats */}
						<div style={{ display: "flex", margin: "-20px 16px 0", gap: "12px", position: "relative", zIndex: 1 }}>
							<div style={{ flex: 1, background: "#fff", borderRadius: "12px", padding: "16px 12px", textAlign: "center", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
								<p style={{ fontWeight: 700, fontSize: "18px", color: "#0f172a", margin: 0 }}>{userProfile?.followers || 0}</p>
								<p style={{ fontSize: "12px", color: "#64748b", margin: "2px 0 0" }}>Followers</p>
							</div>
							<div style={{ flex: 1, background: "#fff", borderRadius: "12px", padding: "16px 12px", textAlign: "center", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
								<p style={{ fontWeight: 700, fontSize: "18px", color: "#0f172a", margin: 0 }}>{userProfile?.following || 0}</p>
								<p style={{ fontSize: "12px", color: "#64748b", margin: "2px 0 0" }}>Following</p>
							</div>
						</div>

						{/* Details */}
						<div style={{ padding: "24px 20px" }}>
							<h6 style={{ fontWeight: 600, color: "#0f172a", marginBottom: "16px", fontSize: "15px" }}>Details</h6>
							{[
								{ label: "Email", value: userProfile?.email },
								{ label: "DOB", value: userProfile?.dob },
								{ label: "Gender", value: userProfile?.gender },
								{ label: "Contact", value: userProfile?.mobileNumber },
								{ label: "Location", value: userProfile?.location },
								{ label: "Instagram", value: userProfile?.instagramHandle, link: userProfile?.instagramHandle ? `https://instagram.com/${userProfile.instagramHandle}` : null },
								{ label: "TikTok", value: userProfile?.tiktokHandle, link: userProfile?.tiktokHandle ? `https://tiktok.com/@${userProfile.tiktokHandle}` : null },
								{ label: "Seller", value: userProfile?.isSeller ? "Yes" : "No" },
							].map((item, i) => (
								<div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: i < 7 ? "1px solid #f1f5f9" : "none" }}>
									<span style={{ color: "#64748b", fontSize: "13px", fontWeight: 500 }}>{item.label}</span>
									{item.link ? (
										<a href={item.link} target='_blank' rel='noopener noreferrer' style={{ color: "#e54a13", fontSize: "13px", fontWeight: 500, textDecoration: "none" }}>
											@{item.value}
										</a>
									) : (
										<span style={{ color: "#334155", fontSize: "13px", fontWeight: 500, textAlign: "right", maxWidth: "60%", wordBreak: "break-word" }}>{item.value || "-"}</span>
									)}
								</div>
							))}
						</div>
					</div>
				</div>

				{/* Order Table */}
				<div className='col-xl-9 col-md-12'>
					<div style={{ background: "#fff", borderRadius: "16px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
						<div style={{ padding: "20px 24px", borderBottom: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
							<h5 style={{ fontWeight: 700, color: "#0f172a", margin: 0 }}>Orders</h5>
							<div className='dropdown'>
								<button type='button' className='btn' onClick={() => setDropdownOpen(!dropdownOpen)} style={{ borderRadius: "8px", padding: "8px 20px", border: "1px solid #e2e8f0", fontSize: "13px", fontWeight: 500, color: "#334155", background: "#fff" }}>
									{status || "Status"} <i className='fa-solid fa-chevron-down ms-1' style={{ fontSize: "10px" }}></i>
								</button>
								{dropdownOpen && (
									<ul className='dropdown-menu show' style={{ display: "block", position: "absolute", top: "100%", right: 0, zIndex: 1000, borderRadius: "10px", border: "1px solid #e2e8f0", boxShadow: "0 4px 12px rgba(0,0,0,0.08)", padding: "4px" }}>
										{["All", "Pending", "Confirmed", "Out Of Delivery", "Delivered", "Cancelled"].map((opt) => (
											<li key={opt}>
												<button
													className='dropdown-item'
													style={{ borderRadius: "6px", fontSize: "13px", padding: "8px 16px" }}
													onClick={() => {
														setStatus(opt);
														setDropdownOpen(false);
													}}>
													{opt}
												</button>
											</li>
										))}
									</ul>
								)}
							</div>
						</div>

						<div style={{ overflowX: "auto", minHeight: "480px" }}>
							<table className='table table-hover mb-0'>
								<thead>
									<tr style={{ background: "#f8fafc" }}>
										<th style={thStyle}>No</th>
										<th style={thStyle}>Order ID</th>
										<th style={thStyle}>Items</th>
										<th style={thStyle}>Price ({defaultCurrency?.symbol})</th>
										<th style={thStyle}>Shipping ({defaultCurrency?.symbol})</th>
										<th style={thStyle}>Payment</th>
										<th style={thStyle}>Status</th>
									</tr>
								</thead>
								<tbody>
									{data?.length > 0 ? (
										data.map((mapData, orderIndex) => {
											const itemCount = mapData.items.length;
											return mapData.items.map((item, itemIndex) => (
												<tr key={`${mapData?.orderId}-${itemIndex}`} onClick={() => handleOpen(mapData)} style={{ cursor: "pointer" }}>
													{itemIndex === 0 && (
														<>
															<td rowSpan={itemCount} style={tdStyle}>
																{orderIndex + 1}
															</td>
															<td rowSpan={itemCount} style={{ ...tdStyle, color: "#e54a13", fontWeight: 600 }}>
																{mapData?.orderId}
															</td>
														</>
													)}
													<td style={tdStyle}>
														<div className='d-flex align-items-center gap-2'>
															<img src={item.productId?.mainImage} width={40} height={40} alt='' style={{ borderRadius: "8px", objectFit: "cover" }} />
															<span style={{ fontSize: "13px" }}>{item.productId?.productName}</span>
														</div>
													</td>
													<td style={tdStyle}>{formatAmount(item.purchasedTimeProductPrice)}</td>
													<td style={tdStyle}>{formatAmount(item.purchasedTimeShippingCharges)}</td>
													<td style={tdStyle}>
														{mapData?.paymentStatus === 1 && <span className='status-badge status-badge--cod'>COD</span>}
														{mapData?.paymentStatus === 2 && <span className='status-badge status-badge--paid'>Paid</span>}
														{mapData?.paymentStatus === null && <span style={{ color: "#94a3b8" }}>—</span>}
													</td>
													<td style={tdStyle}>
														<span className={`status-badge ${statusColorMap[item.status] || "status-badge--pending"}`}>{item.status}</span>
													</td>
												</tr>
											));
										})
									) : (
										<tr>
											<td colSpan='7' style={{ textAlign: "center", padding: "48px 0", color: "#94a3b8" }}>
												No orders found
											</td>
										</tr>
									)}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const thStyle = {
	fontSize: "12px",
	fontWeight: 600,
	color: "#64748b",
	textTransform: "uppercase",
	letterSpacing: "0.5px",
	padding: "12px 16px",
	whiteSpace: "nowrap",
	borderBottom: "1px solid #e2e8f0",
};

const tdStyle = {
	padding: "12px 16px",
	fontSize: "13px",
	color: "#334155",
	verticalAlign: "middle",
};

export default connect(null, { getUserProfile, userIsBlock, getUserOrder })(UserProfile);
